// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2-WsT","boxTitle":"Qualiphy_boxTitle__31UD0","box":"Qualiphy_box__1S2HT","toggleWrap":"Qualiphy_toggleWrap__1JkSt"};